<template>
  <div @click="open">
    <slot />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { createOptimisticConversation } from './config/optimistic'

export default {
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    title: {
      type: [String, Number],
      default: null
    },
    label: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters('gotchiClient', ['hasDraftConversation']),
    ...mapState('gotchiClient', ['windowMessenger'])
  },
  methods: {
    ...mapActions('gotchiClient', ['setDraftConversation']),
    ...mapMutations('gotchiClient', ['toggleWindowMessenger', 'toggleWindowConversation', 'setConversation']),

    open () {
      const optimistic = createOptimisticConversation({
        title: this.title,
        labels: this.label
      })
      this.setDraftConversation(optimistic)
      if (!this.windowMessenger.active) {
        this.toggleWindowMessenger()
      }
      this.toggleWindowConversation(true)
    }
  }
}
</script>
